import React, { useState, useEffect, useContext } from 'react';
import {
  Container, Box, TextField, Button, Dialog, DialogContent,
  DialogTitle, Grid, MenuItem, IconButton, InputAdornment,
  Tooltip, Typography, RadioGroup, FormControlLabel, Radio, FormLabel, Switch,
  FormControl, Select
} from '@mui/material';
import Swal from 'sweetalert2';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import ReusableTable from '../components/tables/resuabletable';
import * as XLSX from 'xlsx';
import { AuthContext } from '..';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format, parse } from 'date-fns';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import { PlaylistAdd } from '@mui/icons-material';

export default function Employees() {
  const [tab, setTab] = useState({ value: '1' });
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingEmployeeId, setEditingEmployeeId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [editingId, setEditingId] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const { companyid, permissions, employmentTypeData, departmentData, salaryFrequencyData, sourceTypeData, token } = useContext(AuthContext);
  const [editicon, setEditicon] = useState(true);
  const [deleteicon, setDeleteicon] = useState(true);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [assignFollowUp, setAssignFollowUp] = useState('no');
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [pagination, setPagination] = useState({ page: 0, rowsPerPage: 10 });
  const [totalrows, setTotalrows] = useState(0);
  const [opencolspaper, setOpencolspaper] = useState(false);
  const [columnOrder, setColumnOrder] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const [formData, setFormData] = useState({
    companyid: '',
    employeeName: '',
    email: '',
    phoneNumber: '',
    secondaryContact: '',
    dob: null,
    gender: '',
    hireDate: null,
    jobPosition: '',
    department: '',
    employmentType: '',
    salary: '',
    paymentFrequency: '',
    bankAccountNumber: '',
    bankName: '',
    ifscCode: '',
    branchName: '',
    city: '',
    state: '',
    country: '',
    followUpDuty: 'no',
    leadSource: '',
    emailAlerts: 'no'
  });

  const handlePaginationChange = (paginationData) => {
    setPagination(paginationData);
  };

  const roles = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/roles/roles`, {
      headers:
      {
        Authorization: `bearer ${token}`
      },
      withCredentials: true
    })
      .then(res => setRolesList(res.data))
      .catch(err => console.error("Error fetching roles:", err));
  };

  const refreshData = () => {
    if (!companyid) return;
    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/countries`,
      {
        headers: {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      }
    )
      .then(res => setCountries(res.data))
      .catch(err => console.error('Failed to fetch countries:', err));
    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/states`,
      {
        headers: {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      }
    )
      .then(res => setStates(res.data))
      .catch(err => console.error('Failed to fetch states:', err));
    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/cities`,
      {
        headers: {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      }
    )
      .then(res => setCities(res.data))
      .catch(err => console.error('Failed to fetch cities:', err));
  };

  useEffect(() => {
    if (tab.value == 2) {
      setDeleteicon(false);
      setEditicon(true);
    } else {
      setDeleteicon(true);
      setEditicon(true);
    }
  }, [tab]);
  const getemployeeButtonLabel = (editingcleadid, tab) => {
    if (!editingcleadid) return "Submit";
    if (tab == 1) return "Update";
    if (tab == 2) return "Make Active";
    if (tab == 3) return "Add";
    return "Update";
  };

  const formatDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return '';
    try {
      const parsed = parse(dateStr, 'dd/MM/yyyy HH:mm', new Date());
      return isNaN(parsed) ? '' : format(parsed, 'dd/MM/yyyy');
    } catch { return ''; }
  };

  const parseDateSafely = (dateStr, formatStr = 'dd/MM/yyyy') => {
    if (!dateStr || typeof dateStr !== 'string' || dateStr === '00/00/0000') return null;
    try {
      const parsed = parse(dateStr, formatStr, new Date());
      return isNaN(parsed) ? null : parsed;
    } catch { return null; }
  };

  const permissionsaccess = () => {
    const employeemodule = permissions.employees || {};
    setDeleteicon(employeemodule.delete === true);
    setEditicon(employeemodule.update === true);
  };

  useEffect(() => {
    if (companyid) {
      setFormData(prev => ({ ...prev, companyid }));
      fetchEmployees();
      roles();
      refreshData();
    }
  }, [companyid, tab, appliedFilters, pagination]);

  useEffect(() => {
    if (permissions && permissions.employees) permissionsaccess();
  }, [permissions]);

  const fetchEmployees = () => {
    const payload = {
      filters: JSON.stringify(appliedFilters),
      currentpage: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      tab: tab.value
    };

    axios.get(`${process.env.REACT_APP_API_LINKS}/employees/getemployees`, {
      params: payload,
      withCredentials: true
    })
      .then((res) => {
        const newColumns = res.data.columns.map(col => {
          if (['dob', 'hire_date', 'created_on', 'updated_on'].includes(col.field))
            return { ...col, field: `display_${col.field}` };
          return col;
        });
        setColumns(newColumns);
        setColumnOrder(newColumns.filter(col => !col.hide).map(col => col.field));

        const total = res.data.totalrows?.[0] || { totalusers: 0 };
        setTotalrows(total.totalusers);

        const formattedRows = res.data.data.map(employee => {
          const dob = parseDateSafely(employee.dob, 'dd/MM/yyyy');
          const hire_date = parseDateSafely(employee.hire_date, 'dd/MM/yyyy');
          return {
            ...employee,
            dob,
            hire_date,
            display_dob: dob ? format(dob, 'dd/MM/yyyy') : '',
            display_hire_date: hire_date ? format(hire_date, 'dd/MM/yyyy') : '',
            display_created_on: employee.created_on ? formatDate(employee.created_on) : '',
            display_updated_on: employee.updated_on ? formatDate(employee.updated_on) : '',
          };
        });
        setRows(formattedRows);
      })
      .catch(err => {
        console.error('Error fetching employees:', err);
        setColumns([]); setRows([]);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (name, date) => {
    setFormData(prev => ({ ...prev, [name]: date }));
  };

  const handleFollowUpChange = (e) => {
    const value = e.target.value;
    setAssignFollowUp(value);
    setFormData(prev => ({ ...prev, followUpDuty: value }));
    if (value === 'no') setFormData(prev => ({ ...prev, leadSource: '' }));
  };

  const handleSwitchChange = (name, checked) => {
    setFormData(prev => ({ ...prev, [name]: checked ? 'yes' : 'no' }));
  };

  const handleSubmit = () => {
    const payload = {
      ...formData,
      companyid: companyid || formData.companyid,
      dob: formData.dob ? format(formData.dob, 'yyyy-MM-dd') : null,
      hireDate: formData.hireDate ? format(formData.hireDate, 'yyyy-MM-dd') : null,
      emailAlerts: formData.emailAlerts,
    };

    if (editingEmployeeId) {
      const data = { tab: tab.value }
      axios.put(`${process.env.REACT_APP_API_LINKS}/employees/updateemployee/${editingEmployeeId}`, payload, {
        params: data, headers:
        {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      })
        .then(res => {
          if (res.status === 200) {
            showSuccess('Employee updated successfully');
            setOpenDialog(false); setEditingEmployeeId(null); setEditingId(false); fetchEmployees();
          }
        })
        .catch(err => {
          if (err.response?.status === 409) {
            showError('Employee Email Already exists');
          } else {
            showError('Failed to update employee.');
          }
        });
    } else {
      axios.post(`${process.env.REACT_APP_API_LINKS}/employees/addemployee`, payload,
        {
          headers:
          {
            Authorization: `bearer ${token}`
          },
          withCredentials: true
        }
      )
        .then(res => {
          if (res.status === 201 || res.status === 200) {
            showSuccess('Employee added successfully');
            setOpenDialog(false); fetchEmployees();
          }
        })
        .catch(err => {
          if (err.response?.status === 409) {
            showWarning('An employee with similar data already exists');
          } else {
            showError('Failed to add employee.');
          }
        });
    }
  };

  const handleEdit = (employee) => {
    const getIdFromValue = (list, value, key = 'value') => {
      if (!list || !value) return '';
      const match = list.find(item => String(item[key]).toLowerCase() === String(value).toLowerCase());
      return match ? match.id : '';
    };
    const getLocationId = (list, name) => {
      if (!name) return '';
      const match = list.find(item => item.name.toLowerCase() === name.toLowerCase());
      return match ? match.id : '';
    };

    setFormData({
      companyid,
      employeeName: employee.employee_name || '',
      email: employee.email || '',
      phoneNumber: employee.phone_number || '',
      secondaryContact: employee.secondary_contact || '',
      dob: employee.dob ? new Date(employee.dob) : null,
      gender: employee.gender || '',
      hireDate: employee.hire_date ? new Date(employee.hire_date) : null,
      jobPosition: getIdFromValue(rolesList, employee.job_position, 'role'),
      department: getIdFromValue(departmentData, employee.department_name),
      employmentType: getIdFromValue(employmentTypeData, employee.employment_type_name),
      salary: employee.salary || '',
      paymentFrequency: getIdFromValue(salaryFrequencyData, employee.payment_frequency_name),
      bankAccountNumber: employee.bank_account_number || '',
      bankName: employee.bank_name || '',
      ifscCode: employee.ifsc_code || '',
      branchName: employee.branch_name || '',
      city: getLocationId(cities, employee.city),
      state: getLocationId(states, employee.state),
      country: getLocationId(countries, employee.country),
      followUpDuty: employee.followUpDuty || 'no',
      leadSource: employee.leadSource || '',
      emailAlerts: employee.emailAlerts || 'no'
    });

    setAssignFollowUp(employee.followUpDuty || 'no');
    setEditingId(true);
    setEditingEmployeeId(employee.id);
    setOpenDialog(true);
  };

  const handleDelete = (employee) => {
    Swal.fire({
      title: `Delete employee "${employee.employee_name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    }).then(result => {
      if (result.isConfirmed) {
        const payload = { tab: tab.value };
        axios.delete(`${process.env.REACT_APP_API_LINKS}/employees/deleteemployee/${employee.id}`, {
          params: payload, headers:
          {
            Authorization: `bearer ${token}`
          },
          withCredentials: true
        })
          .then(() => {
            showSuccess('Employee has been deleted.');
            fetchEmployees();
          })
          .catch(() => showError('Failed to delete employee.'));
      }
    });
  };

  const handleSearch = (e) => setSearchQuery(e.target.value.toLowerCase());

  const filteredColumns = columnOrder
    .map(field => columns.find(col => col.field === field))
    .filter(col => col && !col.hide);

  const filteredRows = rows
    .filter(row => {
      const q = searchQuery;
      return (
        row.employee_name?.toLowerCase().includes(q) ||
        row.email?.toLowerCase().includes(q) ||
        row.phone_number?.toLowerCase().includes(q) ||
        row.job_position?.toLowerCase().includes(q) ||
        row.department_name?.toLowerCase().includes(q) ||
        (row.display_dob || '').toLowerCase().includes(q) ||
        (row.display_hire_date || '').toLowerCase().includes(q) ||
        (row.display_created_on || '').toLowerCase().includes(q) ||
        (row.display_updated_on || '').toLowerCase().includes(q)
      );
    })
    .map(row => ({
      ...row,
      display_dob: row.dob ? format(row.dob, 'dd/MM/yyyy') : '',
      display_hire_date: row.hire_date ? format(row.hire_date, 'dd/MM/yyyy') : '',
      display_created_on: row.created_on ? formatDate(row.created_on) : '',
      display_updated_on: row.updated_on ? formatDate(row.updated_on) : '',
    }));

  const formatEmployeesData = (rows) => {
    return rows.map((row, index) => {
      const formattedRow = { S_No: index + 1 };
      filteredColumns.forEach(col => {
        if (col.headerName === 'S.No' || col.headerName === 'S.NO') return;
        let field = col.field;
        let value = row[field];
        if (field.startsWith('display_')) value = row[col.field];
        else if (['dob', 'hire_date', 'created_on', 'updated_on'].includes(field))
          value = row[`display_${field}`] || '';
        formattedRow[col.headerName || col.field] = value || '';
      });
      return formattedRow;
    });
  };

  const exportToExcel = () => {
    const rowsToExport = selectedIds.length > 0
      ? filteredRows.filter(row => selectedIds.includes(row.id))
      : filteredRows;
    const exportData = formatEmployeesData(rowsToExport);
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees');
    XLSX.writeFile(workbook, 'employees_data.xlsx');
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

        if (!worksheet.length) {
          return Swal.fire('Error', 'Excel sheet is empty', 'error');
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_LINKS}/employees/bulkinsert`,
          { employees: worksheet, companyid },
          {
            headers:
            {
              Authorization: `bearer ${token}`
            },
            withCredentials: true
          }
        );

        if (response.status === 200 || response.status === 201) {
          Swal.fire('Success', 'Employees imported successfully', 'success');
          fetchEmployees();
        }
      } catch (error) {
        console.error('Bulk upload error:', error);
        Swal.fire('Error', 'Failed to import employees. Please check the file format.', 'error');
      }
    };

    reader.readAsArrayBuffer(file);
    refreshData();
  };


  const showSuccess = (msg) => Swal.fire({ icon: 'success', title: 'Success', text: msg, timer: 1500, timerProgressBar: true });
  const showError = (msg) => Swal.fire({ icon: 'error', title: 'Error', text: msg, timer: 2000, timerProgressBar: true });
  const showWarning = (msg) => Swal.fire({ icon: 'warning', title: 'Warning', text: msg, timer: 2000, timerProgressBar: true });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container maxWidth={false} disableGutters sx={{
        px: { xs: 2, sm: 3, md: 4 }, py: 3, fontFamily: 'Libre Franklin',
        backgroundColor: '#ffffff', minHeight: '100vh',
        boxShadow: { xs: 'none', sm: '0px 0px 5px rgba(187, 222, 241, 0.9)', borderRadius: 10 }
      }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
            justifyContent: { md: 'space-between' },
            alignItems: { md: 'center' },
            gap: 2,
            mb: 2
          }}
        >

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'column', md: 'row' },
              justifyContent: 'flex-start',
              alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center' },
              width: '100%',
              gap: 1
            }}
          >
            <TextField
              placeholder="Search by Name, Email or Position"
              size="small"
              variant="outlined"
              sx={{ minWidth: 200, width: { xs: '100%', sm: '100%', md: 200, lg: 450 } }}
              value={searchQuery}
              onChange={handleSearch}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />

            {/* <FormControl
              size="small"
              sx={{ width: { lg: 160, md: 400, sm: 400, xs: '100%' } }}
            >
              <Select
                value={tab.value}
                onChange={(e) => {
                  setTab(prev => ({ ...prev, value: e.target.value }));
                  setAppliedFilters([]);
                  setPagination(prev => ({ ...prev, page: 0 }));
                }}
                sx={{
                  fontSize: '12px',
                  '& .MuiSelect-select': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1,
                    fontFamily: 'Libre Franklin',
                    fontSize: '13px',
                  }
                }}
              >
                <MenuItem
                  value="1"
                  sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}
                >
                  <span style={{ fontFamily: "Libre Franklin", fontSize: "13px" }}>Active</span>
                  <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "green" }} />
                </MenuItem>

                <MenuItem
                  value="2"
                  sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}
                >
                  <span style={{ fontFamily: "Libre Franklin", fontSize: "13px" }}>Inactive</span>
                  <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "red" }} />
                </MenuItem>

                <MenuItem
                  value="3"
                  sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}
                >
                  <span style={{ fontFamily: "Libre Franklin", fontSize: "13px" }}>Bulk-Failed</span>
                  <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "#ff9800" }} />
                </MenuItem>
              </Select>
            </FormControl> */}
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-end' },
              width: '100%',
              gap: 1,
              flexWrap: { xs: 'nowrap', sm: 'nowrap', md: 'nowrap' }
            }}
          >
            {permissions.employees?.create && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  setFormData({
                    companyid, employeeName: '', email: '', phoneNumber: '', secondaryContact: '',
                    dob: null, gender: '', hireDate: null, jobPosition: '', department: '',
                    employmentType: '', salary: '', paymentFrequency: '', bankAccountNumber: '',
                    bankName: '', ifscCode: '', branchName: '', city: '', state: '', country: '',
                    followUpDuty: 'no', leadSource: '', emailAlerts: 'no'
                  });
                  setAssignFollowUp('no');
                  setEditingEmployeeId(null);
                  setEditingId(false);
                  setOpenDialog(true);
                }}
                sx={{ backgroundColor: '#0b85c8', whiteSpace: 'nowrap', fontFamily: 'Libre Franklin', borderRadius: 2 }}
              >
                Add Employee
              </Button>
            )}

            <Tooltip arrow title='Export to Excel'>
              <IconButton onClick={exportToExcel} sx={{ color: '#0b85c8' }}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>

            <input accept=".xlsx,.xls" style={{ display: 'none' }} id="bulk-upload" type="file" onChange={handleFileUpload} />
            <label htmlFor="bulk-upload">
              <Tooltip arrow title="Bulk Import">
                <IconButton component="span" sx={{ color: '#0b85c8' }}>
                  <CloudUploadIcon />
                </IconButton>
              </Tooltip>
            </label>

            <Tooltip title="Customize Columns" arrow>
              <IconButton onClick={() => setOpencolspaper(true)} sx={{ color: '#0b85c8', padding: '8px' }}>
                <ViewColumnIcon />
              </IconButton>
            </Tooltip>
            {opencolspaper && (
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  zIndex: 1300,
                  borderRadius: 2,
                  position: 'absolute',
                  top: { lg: '90px', xs: '185px', sm: '140px', md: '90px' },
                  right: '30px',
                  width: { xs: '280px', sm: '320px', md: '280px' },
                  maxWidth: '320px',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontFamily: 'Libre Franklin',
                      fontWeight: 600,
                      color: '#0b85c8',
                      fontSize: { xs: '13px', sm: '14px', md: '15px' },
                    }}
                  >
                    Customize Columns
                  </Typography>
                  <IconButton onClick={() => setOpencolspaper(false)} size="small">
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Box sx={{ mb: 1 }}>
                  <Button
                    variant="text"
                    onClick={() => {
                      const allSelected = columns.every(column => !column.hide);
                      if (allSelected) {
                        const updatedColumns = columns.map(column => ({ ...column, hide: true }));
                        setColumns(updatedColumns);
                        setColumnOrder([]);
                      } else {
                        const updatedColumns = columns.map(column => ({ ...column, hide: false }));
                        setColumns(updatedColumns);
                        setColumnOrder(columns.map(column => column.field));
                      }
                    }}
                    sx={{
                      fontFamily: 'Libre Franklin',
                      fontSize: { xs: '11px', sm: '12px', md: '13px' },
                      textTransform: 'none',
                      color: '#0b85c8',
                      p: 0,
                      minWidth: 'auto',
                      '&:hover': {
                        backgroundColor: 'transparent',
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    {columns.every(column => !column.hide) ? 'Unselect All' : 'Select All'}
                  </Button>
                </Box>
                <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
                  {columns.map((column) => (
                    <Box key={column.field} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Checkbox
                        checked={!column.hide}
                        onChange={(e) => {
                          const updatedColumns = columns.map((col) =>
                            col.field === column.field ? { ...col, hide: !e.target.checked } : col
                          );
                          setColumns(updatedColumns);
                          if (e.target.checked) {
                            setColumnOrder((prev) => {
                              if (!prev.includes(column.field)) {
                                return [...prev, column.field];
                              }
                              return prev;
                            });
                          } else {
                            setColumnOrder((prev) => prev.filter(field => field !== column.field));
                          }
                        }}
                        sx={{ mr: 1, p: 0.5 }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Libre Franklin',
                          fontSize: { xs: '12px', sm: '13px', md: '14px' },
                        }}
                      >
                        {column.headerName || column.field}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            )}
          </Box>
        </Box>

        <Box sx={{ overflowX: 'auto', width: '100%' }}>
          <ReusableTable
            columns={filteredColumns}
            rows={filteredRows}
            onEdit={handleEdit}
            onDelete={handleDelete}
            editicon={editicon}
            deleteicon={deleteicon}
            pdf={false}
            onApplyFilters={setAppliedFilters}
            onPaginationChange={handlePaginationChange}
            totalrows={totalrows}
            onSelectionChange={setSelectedIds}
          />
        </Box>

        <Dialog open={openDialog} maxWidth="sm" fullWidth>
          <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ backgroundColor: '#f0f9ff' }}>
            <DialogTitle sx={{ fontFamily: 'Libre Franklin', color: '#0b85c8', margin: 'auto', fontWeight: 600 }}>
              {editingEmployeeId ? 'Edit Employee' : 'Add New Employee'}
            </DialogTitle>
            <IconButton onClick={() => setOpenDialog(false)} sx={{ color: '#fff' }}>
              <CloseIcon sx={{ bgcolor: '#0b85c8', borderRadius: 2, mr: 2 }} />
            </IconButton>
          </Box>
          <DialogContent sx={{ fontFamily: 'Libre Franklin', backgroundColor: '#f0f9ff', mt: -1, justifyContent: 'center' }}>
            <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Libre Franklin', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
              <Typography fontWeight={600} mb={1} mt={2} ml={2}>Employee Details</Typography>
              <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
                <TextField
                  label="Employee Name"
                  name="employeeName"
                  value={formData.employeeName}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "98%", md: '98%' } }}
                />
                <TextField
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />
                <TextField
                  label="Phone Number"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />
                <TextField
                  label="Secondary Contact"
                  name="secondaryContact"
                  value={formData.secondaryContact}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />
                <DatePicker
                  label="Date of Birth"
                  value={formData.dob}
                  onChange={(date) => handleDateChange('dob', date)}
                  format="dd/MM/yyyy"
                  slotProps={{
                    textField: {
                      size: 'small',
                      required: true,
                      sx: {
                        width: { lg: '48%', xs: '100%', sm: '100%', md: '48%' },
                        '& .MuiInputBase-root': { height: 36 },
                        '& .MuiInputBase-input': { padding: '8px 10px', height: '20px' }
                      }
                    }
                  }}
                />
                <TextField
                  select
                  label="Gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                >
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </TextField>
                <DatePicker
                  label="Hire Date"
                  value={formData.hireDate}
                  onChange={(date) => handleDateChange('hireDate', date)}
                  format="dd/MM/yyyy"
                  slotProps={{
                    textField: {
                      size: 'small',
                      required: true,
                      sx: {
                        width: { lg: '48%', xs: '100%', sm: '100%', md: '48%' },
                        '& .MuiInputBase-root': { height: 36 },
                        '& .MuiInputBase-input': { padding: '8px 10px', height: '20px' }
                      }
                    }
                  }}
                />
                <TextField
                  select
                  label="Job Position"
                  name="jobPosition"
                  value={formData.jobPosition}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                >
                  {rolesList.map((role) => (
                    <MenuItem key={role.id} value={role.id}>
                      {role.role}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  label="Department"
                  name="department"
                  value={formData.department}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                >
                  {departmentData?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value.charAt(0).toUpperCase() + item.value.slice(1).toLowerCase()}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  label="Employment Type"
                  name="employmentType"
                  value={formData.employmentType}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                >
                  {employmentTypeData?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value.charAt(0).toUpperCase() + item.value.slice(1).toLowerCase()}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  label="Country"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { xs: '100%', sm: '100%', lg: '48%', md: '48%' } }}
                >
                  <MenuItem value="" disabled>Select Country</MenuItem>
                  {countries.map((country) => (
                    <MenuItem key={country.id} value={country.id}>
                      {country.name}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  label="State"
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { xs: '100%', sm: '100%', lg: '48%', md: '48%' } }}
                >
                  <MenuItem value="" disabled>Select State</MenuItem>
                  {states
                    .filter(state => state.country_id === parseInt(formData.country))
                    .map((state) => (
                      <MenuItem key={state.id} value={state.id}>
                        {state.name}
                      </MenuItem>
                    ))}
                </TextField>
                <TextField
                  select
                  label="City"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { xs: '100%', sm: '100%', lg: '48%', md: '48%' } }}
                >
                  <MenuItem value="" disabled>Select City</MenuItem>
                  {cities
                    .filter(city => city.state_id === parseInt(formData.state))
                    .map((city) => (
                      <MenuItem key={city.id} value={city.id}>
                        {city.name}
                      </MenuItem>
                    ))}
                </TextField>
                <TextField
                  label="Salary"
                  name="salary"
                  value={formData.salary}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />
                <TextField
                  select
                  label="Payment Frequency"
                  name="paymentFrequency"
                  value={formData.paymentFrequency}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                >
                  {salaryFrequencyData?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value.charAt(0).toUpperCase() + item.value.slice(1).toLowerCase()}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Bank Account Number"
                  name="bankAccountNumber"
                  value={formData.bankAccountNumber}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />
                <TextField
                  label="Bank Name"
                  name="bankName"
                  value={formData.bankName}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />
                <TextField
                  label="IFSC Code"
                  name="ifscCode"
                  value={formData.ifscCode}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  required
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />
                <TextField
                  label="Branch Name"
                  name="branchName"
                  value={formData.branchName}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  sx={{ width: { lg: "48%", md: '48%' } }}
                />

                {/* Follow-up Duty Radio Buttons */}
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column-reverse', sm: 'row', md: 'row', lg: 'row' }, justifyContent: { lg: 'space-between', md: 'space-between', sm: 'space-between', xs: 'flex-start' }, width: '100%', mt: 2, px: { lg: 3, md: 2, xs: 1, sm: 0 } }}>
                  <Box >
                    <FormLabel component="legend">Assign Follow-up Duty?</FormLabel>
                    <RadioGroup
                      row
                      name="followUpDuty"
                      value={assignFollowUp}
                      onChange={handleFollowUpChange}
                    >
                      <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                  </Box>
                  <FormControlLabel
                    control={<Switch checked={formData.emailAlerts === 'yes'} onChange={(e) => handleSwitchChange('emailAlerts', e.target.checked)} />}
                    label="Email Alerts"
                    labelPlacement="start"
                    sx={{
                      display: 'flex',
                      justifyContent: { xs: 'start', sm: 'flex-start' },
                      mr: { xs: 3 }
                    }}
                  />
                </Box>

                {assignFollowUp === 'yes' && (
                  <TextField
                    select
                    label="Lead Source"
                    name="leadSource"
                    value={formData.leadSource}
                    onChange={handleInputChange}
                    fullWidth
                    size="small"
                    sx={{ width: { lg: "98%", md: '98%' } }}

                  >
                    <MenuItem value="" disabled>Select Lead Source</MenuItem>
                    {sourceTypeData.map((source) => (
                      <MenuItem key={source.id} value={source.id}>
                        {source.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Grid>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <Button
                variant="contained"
                sx={{ mt: 2, backgroundColor: '#0b85c8', fontFamily: 'Libre Franklin' }}
                onClick={handleSubmit}
              >
                {getemployeeButtonLabel(editingId, tab.value)}
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Container>
    </LocalizationProvider>
  );
}